import { Category } from './types';

export const getFullPath = (path: string[], level: number): string => 
  path.slice(0, level + 1).join('/');

export const getFilledPath = (path: string[], level: number): string => {
  const filledPath = path.map((value, index) => {
    if (value === '') {
      // Find last non-empty value
      for (let i = index - 1; i >= 0; i--) {
        if (path[i] !== '') {
          return path[i];
        }
      }
    }
    return value;
  });
  return filledPath.slice(0, level + 1).join('/');
};

export const fillCategoryPath = (categoryPath: string[]): string[] => {
  return categoryPath.reduce((acc: string[], current, index) => {
    if (current === '') {
      // Find the last non-empty value
      let lastNonEmpty = '';
      for (let i = index - 1; i >= 0; i--) {
        if (acc[i] !== '') {
          lastNonEmpty = acc[i];
          break;
        }
      }
      acc.push(lastNonEmpty);
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
};